import { render } from "./AppUploadArt.vue?vue&type=template&id=09350cce"
import script from "./AppUploadArt.vue?vue&type=script&lang=js"
export * from "./AppUploadArt.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__